const obj = {
    1: {
        slidesPerView: 1.375,
        spaceBetween: 16,
        centeredSlides: true,
        initialSlide: 1
    },
    2: {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    },
    3: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
            renderFraction: function (currentClass, totalClass) {
                return '<span class="' + currentClass + '"></span>' +
                    ' of ' +
                    '<span class="' + totalClass + '"></span>';
            },
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    }
}

class CustomSlider extends HTMLElement {

    connectedCallback() {
        
        this.dataindex = this.dataset.index || 1;
        this.config = obj[this.dataindex];
        this.swiper = new Swiper(this, this.config);
    }
    changeSlide(index) {
        this.swiper.slideTo(index);
    }

    update() {
        this.swiper.update();
    }
}

customElements.define('custom-slider', CustomSlider);